import React from 'react'
import Hero from '../Components/Hero/Hero'
import Popularwomen from '../Components/Popular/Popular'
import Offers from '../Components/Offers/Offers'
import Newcollections from '../Components/NewCollections/Newcollections'
import Newletter from '../Components/Newletter/Newletter'

const Shop = () => {
  return (
    <div>
      <Hero />
      <Popularwomen />
      <Offers />
      <Newcollections/>
      <Newletter/>
    </div>
  )
}

export default Shop
